import _ from "underts";
import { formaters } from "vincent-utils";
import { HourMinute } from "cadendar-shared";
import { Collections } from "cadendar-shared";
const getHms = (hmStart: HourMinute, hmEnd: HourMinute, step: number) => {
  const minutesStart = formaters.getHourAsMinutesFromHMObject(hmStart);
  const minutesEnd = formaters.getHourAsMinutesFromHMObject(hmEnd);
  let minutes = [];
  for (let i = minutesStart; i <= minutesEnd; i += step) {
    minutes.push(i);
  }
  return _.compact(
    minutes.map(formaters.getHeureMinuteObjectFromHeureEnMinutes)
  );
};

const getExtremesFromDayPlages = (dayPlages: Collections.Plage[]) => {
  if (!dayPlages || dayPlages.length === 0) {
    return;
  }
  return { start: _.first(dayPlages)!.start, end: _.last(dayPlages)!.end };
};

export { getHms, getExtremesFromDayPlages };
